(function () {
  'use strict';
  if (window.__verticalGalleryInit) return;
  window.__verticalGalleryInit = true;

  const MQL = window.matchMedia('(min-width: 1024px)');

  // サムネイルクリック: MediaDots.onButtonClick をデスクトップ用に差し替え
  customElements.whenDefined('media-dots').then(() => {
    const MediaDotsClass = customElements.get('media-dots');
    if (!MediaDotsClass || MediaDotsClass.prototype.__verticalPatched) return;
    MediaDotsClass.prototype.__verticalPatched = true;

    const original = MediaDotsClass.prototype.onButtonClick;

    MediaDotsClass.prototype.onButtonClick = function (event) {
      if (!MQL.matches) {
        return original.call(this, event);
      }

      event.preventDefault();
      const btn = event.currentTarget;
      const mediaId = btn.getAttribute('data-media-id');
      const sliderEl = this.controlledElement;

      if (sliderEl && mediaId) {
        const target = sliderEl.querySelector(`.product__media[data-media-id="${mediaId}"]`);
        if (target) {
          // --header-height はテーマが管理する CSS 変数（デフォルト 0px）
          const headerHeight = parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue('--header-height')
          ) || 0;
          const rawTop = target.getBoundingClientRect().top + window.scrollY;
          // 下スクロール時はヘッダーが隠れるためオフセット不要、上スクロール時はヘッダー分を引く
          const isScrollingDown = rawTop > window.scrollY;
          const top = rawTop - (isScrollingDown ? 0 : headerHeight);

          // スクロール中は IntersectionObserver の aria-current 更新を抑制
          this.__ignoreObserver = true;
          const dots = this;
          let clearTimer;
          const clearIgnore = () => {
            clearTimeout(clearTimer);
            dots.__ignoreObserver = false;
          };
          window.addEventListener('scrollend', clearIgnore, { once: true });
          clearTimer = setTimeout(clearIgnore, 800);

          window.scrollTo({ top, behavior: 'smooth' });
        }
      }

      this.itemsToShow.forEach((item) => {
        item.setAttribute('aria-current', item === btn ? 'true' : 'false');
      });

      // media-dots を選択サムネイルまでスクロール（scroll-shadow 矢印の更新に必要）
      const index = this.itemsToShow.indexOf(btn);
      if (index !== -1) this.transitionTo(index);
    };
  });

  // IntersectionObserver: スクロール中のアクティブサムネイルを更新（ページ操作なし）
  function init() {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      const mediaDots = gallery.querySelector('media-dots');
      const sliderEl = gallery.querySelector('slider-element');
      if (!mediaDots || !sliderEl) return;

      let observer;

      function setupObserver() {
        if (observer) observer.disconnect();
        if (!MQL.matches) return;

        observer = new IntersectionObserver((entries) => {
          if (mediaDots.__ignoreObserver) return;
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const mediaId = entry.target.getAttribute('data-media-id');
            const thumb = mediaDots.querySelector(`.product__thumbnail[data-media-id="${mediaId}"]`);
            if (!thumb) return;

            // aria-current の更新のみ（scrollIntoView は呼ばない＝ガタつき防止）
            mediaDots.querySelectorAll('.product__thumbnail').forEach((t) => {
              t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
            });
          });
        }, {
          rootMargin: '0px 0px -65% 0px',
          threshold: 0,
        });

        sliderEl.querySelectorAll('.product__media').forEach((el) => observer.observe(el));
      }

      if (MQL.matches) setupObserver();
      MQL.addEventListener('change', (e) => e.matches ? setupObserver() : observer?.disconnect());
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
